import React, { useEffect, useState } from 'react';
import './onboarding-statistics.css';
import apiClient from '../../service/interceptor';
import { Loader } from '../../components';

export default function OnboardingStatistics() {

    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);
    const formatDate = (date) => date.toISOString().split("T")[0];


    const [startDate, setStartDate] = useState(formatDate(lastWeek));
    const [endDate, setEndDate] = useState(formatDate(today));
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [statics, setStatics] = useState({});
    const [staticsWithExercisePlan, setStaticsWithExercisePlan] = useState({});

    useEffect(() => {
        fetchData();
    },[])

    const fetchData = async () => {
        try {
            setIsLoading(true);
            const response = await apiClient.post('v1/analytics/therapy/patient-painType-statics', {
                fromDate: startDate,
                toDate: endDate
            });
            if (response.status === 200) {
                const responseData = response.data?.data || response.data;
                setStatics(responseData.statics);
                setStaticsWithExercisePlan(responseData.staticsWithExercisePlan);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
       isLoading?<Loader/> : <div className="onboarding-statistics-container">
            <div className="dashboard-header">
                <h2>Onboarding Statistics Dashboard</h2>
            </div>
            <div className="statistics-content">
                <div className='onboarding-filter-container'>
                    <div className="onboarding-filter-item">
                        <label htmlFor="startDate">Start Date</label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => { setStartDate(e.target.value); setErrorMessage(""); }}
                            className="date-input"
                        />
                    </div>
                    <div className="onboarding-filter-item">
                        <label htmlFor="endDate">End Date</label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => { setEndDate(e.target.value); setErrorMessage(""); }}
                            className="date-input"
                        />
                    </div>
                    <div className='onboarding-filter-item'>
                        <div></div>
                        <button onClick={() => {fetchData(); }} className="search-button">Search</button>
                    </div>
                </div>

            </div>

            <div>
                <h3>Patients who have not filled up the first questions</h3>
                <table className="pain-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Lower Back</th>
                            <th>Neck</th>
                            <th>Knee</th>
                            <th>Patient who has not completed the first question</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Total</td>
                            <td>{statics.back}</td>
                            <td>{statics.neck}</td>
                            <td>{statics.knee}</td>
                            <td>{statics.no_response}</td>
                            <td>{statics.total}</td>
                        </tr>
                        <tr>
                            <td>Pain 1</td>
                            <td>{statics.back_pain_1}</td>
                            <td>{statics.neck_pain_1}</td>
                            <td>{statics.knee_pain_1}</td>
                            <td>{statics.no_response_pain_1}</td>
                            <td>{statics.pain_1_total}</td>
                        </tr>
                        <tr>
                            <td>Pain 2</td>
                            <td>{statics.back_pain_2}</td>
                            <td>{statics.neck_pain_2}</td>
                            <td>{statics.knee_pain_2}</td>
                            <td>{statics.no_response_pain_2}</td>
                            <td>{statics.pain_2_total}</td>
                        </tr>
                        <tr>
                            <td>Round Table</td>
                            <td>{statics.round_table_back_pain}</td>
                            <td>{statics.round_table_neck_pain}</td>
                            <td>{statics.round_table_knee_pain}</td>
                            <td>{statics.round_table_no_response}</td>
                            <td>{statics.round_table_total}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style={{marginTop:"40px"}}>
                <h3>Patients who got their exercise plan</h3>
                <table className="pain-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Lower Back</th>
                            <th>Neck</th>
                            <th>Knee</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Total</td>
                            <td>{staticsWithExercisePlan.back}</td>
                            <td>{staticsWithExercisePlan.neck}</td>
                            <td>{staticsWithExercisePlan.knee}</td>
                            <td>{staticsWithExercisePlan.total}</td>
                        </tr>
                        <tr>
                            <td>Pain 1</td>
                            <td>{staticsWithExercisePlan.back_pain_1}</td>
                            <td>{staticsWithExercisePlan.neck_pain_1}</td>
                            <td>{staticsWithExercisePlan.knee_pain_1}</td>
                            <td>{staticsWithExercisePlan.pain_1_total}</td>
                        </tr>
                        <tr>
                            <td>Pain 2</td>
                            <td>{staticsWithExercisePlan.back_pain_2}</td>
                            <td>{staticsWithExercisePlan.neck_pain_2}</td>
                            <td>{staticsWithExercisePlan.knee_pain_2}</td>
                            <td>{staticsWithExercisePlan.pain_2_total}</td>
                        </tr>
                        <tr>
                            <td>Round Table</td>
                            <td>{staticsWithExercisePlan.round_table_back_pain}</td>
                            <td>{staticsWithExercisePlan.round_table_neck_pain}</td>
                            <td>{staticsWithExercisePlan.round_table_knee_pain}</td>
                            <td>{staticsWithExercisePlan.round_table_total}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style={{height:"40px",marginTop:"80px"}}></div>
        </div>
    );



}